import React, { Component } from 'react'
import styled from 'styled-components'
import { getTheme } from '../../global/utils'

const Header = styled.div`
  background: ${getTheme('bg', 'light2')};
  padding: ${getTheme('spacer', 'm')} ${getTheme('padding', 'horizontalPage')};
`

class PageHeader extends Component {
  render() {
    return (
      <Header className={this.props.className}>{this.props.children}</Header>
    )
  }
}

export default PageHeader



// WEBPACK FOOTER //
// ./src/components/shared/PageHeader.js